import React from 'react';
import { Container, Row, Col, Button, Card, Modal, Form, Table, Badge } from 'react-bootstrap';
import Nav from '../Components/Nav'
import ModalAlert from '../Components/ModalAlert'
import API from '../API'

export default class Contacts extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            numberOfContacts: 0,
            uploadFilePath:"",
            uploadFile:null,
            showMessage:false,
            messageTitle:"",
            messageText:"",

            // Search
            contactSearchResults:[],
            contactSearchText:"",

            // Edit
            showEditContactModal:false,
            selectedContact:null,

            // New
            showNewContactModal: false,

            // Delete all
            showDeleteAllContactsModal: false,

            // Select groups
            selectedGroups:[],
            showManageGroupModal: false
        }
    }

    componentDidMount(){
        this.updateContacts()
    }

    updateContacts(){
        API.contacts().then(contactsCount=>{
            this.setState({
                numberOfContacts:contactsCount,
                uploadFilePath:"",
                uploadFile:null
            })
        }, error=>{
            // TODO: handle error
        })
    }
    
    didPressDeleteAll() {
        this.setState({
            showDeleteAllContactsModal:true
        })
    }

    didPressConfirmDeleteAll(){
        this.setState({
            showDeleteAllContactsModal:false
        })

         // TODO: add confirmation that we should delete all contacts
         API.deleteContacts().then(contactsCount=>{
            this.setState({numberOfContacts:contactsCount})
        }, error=>{
            // TODO: handle error
        })
    }

    didUploadFile(event){
        const filepath = event.target.value
        this.setState({
            uploadFilePath:filepath,
            uploadFile:event.target.files[0]
        })
    }

    didPressUpload(){

        if(this.state.uploadFile){
            var reader = new FileReader();
            reader.onload = () => {
                var text = reader.result;

                // Process parsing contacts
                // ex. Format
                // MemberId, name, phone (+123456789)

                var error = false

                const contacts = text.split("\n").map(line=>{
                    const parts = line.split(",")

                    try {
                        const memberId = parts[0]
                        const name = parts[1]
                        const phone = parts[2]

                        if(memberId.length === 0 || name.length === 0 || phone.length === 0){
                            error = true
                        }

                        return {
                            memberId:memberId,
                            name:name,
                            phone:phone
                        }
                    } catch (e) {
                        error = true
                        return null
                    }
                })

                if (error){
                    this.setState({
                        showMessage:true,
                        messageText: "Unable to process contacts. Please make sure all contacts have a memberId, name and phone.",
                        messageTitle: "Error"
                    })
                } else {
                    // Upload Contacts
                    API.uploadContacts(contacts, this.state.selectedGroups).then(result => {
                        this.updateContacts()
                        this.setState({
                            showMessage:true,
                            messageText: "Contacts have been successfully updated.",
                            messageTitle: "Success"
                        })
                    }, response => {
                        this.setState({
                            showMessage:true,
                            messageText: response.error,
                            messageTitle: "Error"
                        })
                    })
                }
            };

            // Read File
            reader.readAsText(this.state.uploadFile);
        } else {
            this.setState({
                showMessage:true,
                messageText: "Please select a file with contacts.",
                messageTitle: "Error"
            })
        }
    }

    didPressOk(){
        this.setState({
            showMessage:false,
            showDeleteAllContactsModal:false
        })
    }

    // Search Contact
    didSearchContact(event){
        const searchText = event.target.value
        this.setState({contactSearchText:searchText})
        this.searchContact(searchText)
        
    }
    searchContact(searchText){
        if(searchText.length>0){
            API.searchContact(null, searchText).then(results=>{
                this.setState({contactSearchResults:results})
            }, error=>{
                // TODO: handle error
            })
        } else {
            this.setState({contactSearchResults:[]})
        }
    }

    didPressEditContact(contact){
        console.log(contact)
        this.setState({
            selectedContact:contact,
            showEditContactModal:true
        })
    }

    // Edit
    didPressCancelEditContact(){
        this.setState({
            showEditContactModal:false,
            selectedContact:null
        })
    }

    didPressDoneEditContact(){
        this.setState({
            showDeleteAllContactsModal:false,
            showEditContactModal:false,
            selectedContact:null
        })
    }

    didPressDeleteContact(contact){
        this.setState({
            showEditContactModal:false,
            selectedContact:null
        })

        API.deleteContact(contact.memberId).then(response=>{
            this.searchContact(this.state.contactSearchText)
        }, error=>{
            // TODO: handle error
        })

        // TODO: delete contact add confirmation
    }

    didPressCreateContact(){
        this.setState({
            showNewContactModal:true
        })
    }

    didEditContact(contact){
        this.setState({
            showEditContactModal:false,
            selectedContact:null
        })

        API.uploadContacts([contact],[]).then(response=>{
            this.searchContact(this.state.contactSearchText)
        },error=>{
            // TODO: handle error
        })
    }

    // Create Contact
    didCreateContact(contact){
        this.setState({
            showNewContactModal:false
        })

        API.uploadContacts([contact],[]).then(response=>{
            this.updateContacts()
            this.searchContact(this.state.contactSearchText)
        },error=>{
            // TODO: handle error
        })
    }

    didPressCancelNewContact(){
        this.setState({
            showNewContactModal:false
        })
    }

    // Groups
    didPressRemoveGroup = (removeGroup) =>{
        const groups = this.state.selectedGroups.filter(group=>{ return group.groupId !== removeGroup.groupId })
        this.setState({selectedGroups:groups})
    }

    didPressAddGroup = () => {
        this.setState({
            showManageGroupModal:true
        })
    }

    didChangeSelectedGroups = (selectedGroups) => {
        this.setState({
            selectedGroups:selectedGroups,
            showManageGroupModal:false
        })
    }

    didPressDoneManageGroups = () => {
        this.setState({showManageGroupModal:false})
    }

    render() {

        var filename = this.state.uploadFilePath.length > 0 ? this.state.uploadFilePath : "Choose file"
        filename = this.state.uploadFilePath.split("\\").pop();
        const GroupsList = props=>{
            if(props.groups.length === 0){
              return ( 
                <tr>
                  <td>No Groups Selected</td>
                </tr>
              )
            } else {
              return props.groups.map(group=>{
                  return (
                    <tr key={group.groupId}>
                      <td>{group.name}</td>
                      <td><Button variant="danger" onClick={this.didPressRemoveGroup.bind(this,group)}>Remove</Button></td>
                    </tr>
                  )
                }) 
            }
          }

        const SearchResultItems = props => {
            if(this.state.contactSearchResults.length === 0){
                return (
                    <tr>
                        <td>No Results</td>
                    </tr>
                )
            } else {
                return this.state.contactSearchResults.map((contact,index)=>{
                    return (
                        <tr key={index}>
                            <td>{contact.name}</td>
                            <td>
                                <Button variant="primary" onClick={this.didPressEditContact.bind(this, contact)} >Edit</Button>
                            </td>
                        </tr>
                    )
                }) 
            }
        }

        return (
            <Container fluid>
                <Row>
                    <Nav />
                    <Col xs={6}>
                        <h3 style={{ paddingTop: 10, paddingBottom: 10 }}>Manage Contacts</h3>
                        <Card>
                            <Card.Body>
                                <strong>Contacts Loaded:</strong> {this.state.numberOfContacts}
                                <h6><strong>Note:</strong> Total number of contacts in the system.</h6>
                            </Card.Body>
                        </Card>
                        <br />
                        <Card>
                            <Card.Body>
                                <strong>Create New Contact</strong>
                                <br />
                                <Button variant="primary" style={{ marginTop:10 }} onClick={this.didPressCreateContact.bind(this)}>New Contact</Button>
                            </Card.Body>
                        </Card>
                        <br />
                        <Card>
                            <Card.Body>
                                <Form>
                                    <Form.Group>
                                        <Form.Label><strong>Search Contacts</strong></Form.Label>
                                        <Form.Control type="text" placeholder="Search Contact..." value={this.state.contactSearchText} onChange={this.didSearchContact.bind(this)} />
                                        <br />
                                        <div style={{height:200, overflowY:"auto"}}>
                                            <Table bordered hover>
                                                <tbody>
                                                    <SearchResultItems />
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Form.Group>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                        <Card>
                            <Card.Body>
                            <h6><strong>Bulk Upload Contacts</strong></h6>
                            <h6><strong>Note:</strong> All contacts with matching memberId will be updated.</h6>
                            <form>
                                <div className="custom-file">
                                    <input type="file" id="customFile" onChange={this.didUploadFile.bind(this)}/>
                                    <label className="custom-file-label" htmlFor="customFile">{filename}</label>
                                </div>
                            </form>
                            <hr />
                            <h6><strong>Select Groups</strong></h6>
                            <h6><strong>Notes:</strong> Automatically add imported contacts to the selected groups</h6>
                            <Button style= {{marginBottom:10}} disabled={this.state.selectedGroups.length === 1} variant="primary" onClick={this.didPressAddGroup}>Select Group</Button>
                            <Table bordered >
                                <tbody>
                                <GroupsList groups={this.state.selectedGroups}/>
                                </tbody>
                            </Table>
                            <hr />
                            <Button variant="primary" style={{ marginTop:10 }} disabled={ this.state.uploadFilePath.length === 0 }  onClick={this.didPressUpload.bind(this)}>Upload</Button>
                            </Card.Body>
                        </Card>
                        <br/>
                        <Card>
                            <Card.Body>
                                <h6><strong>Remove All Contacts</strong></h6>
                                <h6><strong>Note:</strong> This will remove all contacts in the system.</h6>
                                <Button variant="danger" style={{ }} onClick={this.didPressDeleteAll.bind(this)}>Delete All Contacts</Button>
                            </Card.Body>
                        </Card>
                        
                        <hr/>
                        {
                            this.state.selectedContact ? (
                                <EditContactModal 
                                    show={this.state.showEditContactModal}
                                    contact={this.state.selectedContact}
                                    didEditContact={this.didEditContact.bind(this)}
                                    didPressCancel={this.didPressCancelEditContact.bind(this)}
                                    didPressDelete={this.didPressDeleteContact.bind(this)} 
                                />
                            )  : (null)
                        }

                        {
                            this.state.showDeleteAllContactsModal ? (
                                <DeleteAllContactsModal 
                                    show={this.state.showDeleteAllContactsModal}
                                    didPressCancel={this.didPressOk.bind(this)}
                                    didPressDelete={this.didPressConfirmDeleteAll.bind(this)} 
                                />
                            )  : (null)
                        }

                        {
                            this.state.showNewContactModal? (
                                <NewContactModal 
                                    show={this.state.showNewContactModal}
                                    didCreateContact={this.didCreateContact.bind(this)}
                                    didPressCancel={this.didPressCancelNewContact.bind(this)}
                                />
                            ) : (null)
                        }

                        {
                            this.state.showManageGroupModal? (
                                <ManageGroupsModal 
                                    show={this.state.showManageGroupModal}
                                    selectedGroups={this.state.selectedGroups}
                                    didChangeSelectedGroups={this.didChangeSelectedGroups}
                                    didPressDone={this.didPressDoneManageGroups}
                                />
                            ) : (null)
                        }
                        
                        <ModalAlert 
                            show={this.state.showMessage} 
                            messageTitle={this.state.messageTitle} 
                            messageText={this.state.messageText}   
                            didPressOk={this.didPressOk.bind(this)}
                        />
                    </Col>
                </Row>
            </Container>
        )
    }
}

class EditContactModal extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            name:"",
            phone:""
        }
    }
    componentDidMount(){
        this.setState({
            name:this.props.contact.name,
            phone:this.props.contact.phone,
        })
    }
    didEditName(event){
        const name = event.target.value
        this.setState({name:name})
    }
    didEditPhone(event){
        const phone = event.target.value
        this.setState({phone:phone})
        // TODO: strip contact characters / Validate format
    }
    didPressSave(){
        var modifiedContact = this.props.contact
        modifiedContact.name = this.state.name
        modifiedContact.phone = this.state.phone
        this.props.didEditContact(modifiedContact)
    }
    render(){
        return (
            <Modal show={this.props.show} onHide={this.props.didPressCancel}>
                <Modal.Header>
                    <Modal.Title>Edit Contact</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label><strong>Name</strong></Form.Label>
                        <Form.Control type="text" placeholder="Full Name" value={this.state.name} onChange={this.didEditName.bind(this)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label><strong>Phone</strong></Form.Label>
                        <Form.Control type="text" placeholder="+13231234567" value={this.state.phone} onChange={this.didEditPhone.bind(this)} />
                    </Form.Group>
                </Form>
                </Modal.Body>
                <Modal.Footer style={{justifyContent:"space-between"}}>
                    <div style={{float:"left"}}>
                        <Button variant="danger" onClick={this.props.didPressDelete.bind(this, this.props.contact)}>Delete</Button> 
                    </div>
                    <div style={{float:"right"}}>
                        <Button style={{marginRight:10}} variant="secondary" onClick={this.props.didPressCancel}>Cancel</Button>
                        <Button variant="primary" onClick={this.didPressSave.bind(this)}>Save</Button>
                    </div>

                </Modal.Footer>
            </Modal>
        )
    }
}

class NewContactModal extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            name:"",
            phone:""
        }
    }
    didEditName(event){
        const name = event.target.value
        this.setState({name:name})
    }
    didEditPhone(event){
        const phone = event.target.value
        this.setState({phone:phone})
        // TODO: strip contact characters / Validate format
    }
    didPressSave(){
        var contact = {
            name : this.state.name,
            phone : this.state.phone
        }
        this.props.didCreateContact(contact)
    }
    render(){
        return (
            <Modal show={this.props.show} onHide={this.props.didPressCancel}>
                <Modal.Header>
                    <Modal.Title>New Contact</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label><strong>Name</strong></Form.Label>
                        <Form.Control type="text" placeholder="Full Name" value={this.state.name} onChange={this.didEditName.bind(this)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label><strong>Phone</strong></Form.Label>
                        <Form.Control type="text" placeholder="+13231234567" value={this.state.phone} onChange={this.didEditPhone.bind(this)} />
                    </Form.Group>
                </Form>
                </Modal.Body>
                <Modal.Footer>
                        <Button style={{marginRight:10}} variant="secondary" onClick={this.props.didPressCancel}>Cancel</Button>
                        <Button variant="primary" onClick={this.didPressSave.bind(this)}>Save</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

class DeleteAllContactsModal extends React.Component {
    render(){
        return (
            <Modal show={this.props.show} onHide={this.props.didPressCancel}>
                <Modal.Header>
                    <Modal.Title>Delete All Contacts</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you would like to delete <strong>ALL</strong> the contacts on the system?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={this.props.didPressDelete}>Delete</Button>   
                    <Button variant="secondary" onClick={this.props.didPressCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

class ManageGroupsModal extends React.Component {

    constructor(props){
      super(props)
      this.state = {
        // Groups
        groups:[]
      }
    }
  
    componentDidMount(){
      this.fetchGroups()
    }
  
    fetchGroups(){
      API.groups().then(groups=>{
          this.setState({groups:groups})
      }, error=>{
          // TODO: handle error
      })
    }
  
    didPressAddGroup(group){
      var selectedGroups = this.props.selectedGroups
      selectedGroups.push(group)
      this.props.didChangeSelectedGroups(selectedGroups)
    }
  
    render(){
  
      const GroupsList = (props) => {
        if(this.state.groups.length === 0){
          return (
            <tr key={0}>
                <td style={{height:70}}>
                    No Groups Found
                </td>
            </tr>
          )
        } else {
          return this.state.groups.map(group=>{
              return (
                <tr key={group.groupId}>
                      <td style={{height:70}}>
                          {group.name} 
                      </td>
                      <td>
                        {
                          this.props.selectedGroups.includes(group) ? (<Badge pill variant="secondary">Added</Badge>) : (<Button onClick={this.didPressAddGroup.bind(this,group)}>Add</Button>)
                        }
                      </td>
                  </tr>
              )
          })
        }
      }
  
      return (
        <Modal show={this.props.show} onHide={this.props.didPressDone}>
          <Modal.Header>
              <Modal.Title>Add Groups</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <br />
            <Table bordered >
              <tbody>
                <GroupsList />
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
              <Button variant="secondary" onClick={this.props.didPressDone}>Done</Button>
          </Modal.Footer>
        </Modal>
      )
    }
  }